import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { DesignSnackEditCreateNewItemPresenter } from "./presenter";
import { useSnackNewItemQuery } from "../../model";

type Props = {
	hotelID: string;
	duplicateItemID: string | undefined;
};

export const DesignSnackEditCreateNewItemContainer = ({ hotelID, duplicateItemID }: Props) => {
	const { data } = useSnackNewItemQuery({ hotelID, duplicateItemID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.LIST, { hotelID })} />;
	}

	return <DesignSnackEditCreateNewItemPresenter hotelID={hotelID} data={data} />;
};

DesignSnackEditCreateNewItemContainer.displayName = "DesignSnackEditCreateNewItemContainer";
